import utils from './utils'

export default {
  nodeEnv: () => process.env.NODE_ENV,
  clientId: () => process.env.VUE_APP_CLIENT_ID || utils.getHostnameBrowser(),
  redirectPath: () => process.env.VUE_APP_AGILE_REDIRECT_PATH || utils.getOriginBrowser(),
  contextPath: () => process.env.VUE_APP_CONTEXT_PATH || utils.getOriginBrowser(),
  apiV1Path: () => process.env.VUE_APP_API_V1_PATH || `${utils.getOriginBrowser()}/webservices/api/v1`,
  apiV3PublicPath: () => process.env.VUE_APP_API_V3_PUBLIC_PATH || `${utils.getOriginBrowser()}/webservices/api/public/v3`,
  apiInvolvesAuth: () => process.env.VUE_APP_INVOLVES_AUTH_PATH,
  releaseVersion: () => process.env.VUE_APP_RELEASE_VERSION || 'DEV',
  latestVersion: () => process.env.VUE_APP_LATEST_VERSION || 'DEV',
  segmentKey: () => process.env.VUE_APP_SEGMENT_IO_KEY || '123',
  segmentDebug: () => process.env.VUE_APP_SEGMENT_DEBUG || false,
  locale: () => process.env.VUE_APP_DEFAULT_LOCALE || utils.getLocaleBrowser(),
  fallbackLocale: () => process.env.VUE_APP_FALLBACK_LOCALE || utils.getDefaultLanguage(),
  getBannerUrl: () => process.env.VUE_APP_BANNER_URL || ''
}
